import { FormLabelProps } from '@/components/elements/enFormLabel'

export const corporationLabels: {
  company: FormLabelProps
  fullName: FormLabelProps
  lastName: FormLabelProps
  firstName: FormLabelProps
  email: FormLabelProps
  tel: FormLabelProps
  title: FormLabelProps
  detail: FormLabelProps
} = {
  company: {
    text: 'Company',
    isRequired: false,
    inputId: 'company',
  },
  fullName: {
    text: 'Name',
    isRequired: true,
    inputId: 'lastName',
  },
  lastName: {
    text: 'First name',  
    isRequired: 'none',
    inputId: 'lastName',
  },
  firstName: {
    text: 'Last name',  
    isRequired: 'none',
    inputId: 'firstName',
  },
  email: {
    text: 'Email Address',
    isRequired: true,
    inputId: 'email',
  },
  tel: {
    text: 'Phone Number',
    isRequired: false,
    inputId: 'tel',
  },
  title: {
    text: 'Subject',
    isRequired: false,
    inputId: 'title',
  },

  detail: {
    text: 'Message',
    isRequired: true,
    inputId: 'detail',
  },
}

export const formData = {
  company: '株式会社 TRIAL',
  lastName: 'トライアル',
  firstName: '太郎',
  email: 'XXX@XXX.ne.jp',
  tel: '009-0000-0000',
  title: '件名が入りますダミー',
  detail:
    'ここに内容が入りますダミーです。ここに内容が入りますダミーです。ここに内容が入りますダミーです。ここに内容が入りますダミーです。ここに内容が入りますダミーです。ここに内容が入りますダミーです。ここに内容が入りますダミーです。ここに内容が入りますダミーです。ここに内容が入りますダミーです。ここに内容が入りますダミーです。ここに内容が入りますダミーです。ここに内容が入りますダミーです。ここに内容が入りますダミーです。ここに内容が入りますダミーです。',
}
